import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getPathToAppMapping } from '../utils/conts';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedApp, setSelectedApp] = useState(() => {
    const stored = localStorage.getItem('selectedApp');
    return stored || 'admin';
  });

  const selectApp = useCallback((appKey, firstPagePath) => {
    setSelectedApp(appKey);
    localStorage.setItem('selectedApp', appKey);
    if (firstPagePath) {
      navigate(firstPagePath);
    }
  }, [navigate]);

  useEffect(() => {
    const pathToAppMapping = getPathToAppMapping();
    
    Object.entries(pathToAppMapping).forEach(([path, appKey]) => {
      if (pathname.startsWith(path)) {
        if (selectedApp !== appKey) {
          setSelectedApp(appKey);
          localStorage.setItem('selectedApp', appKey);
        }
      }
    });
  }, [pathname, selectedApp]);

  return (
    <AppContext.Provider value={{ selectedApp, selectApp }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};
